/**
 * Empty string = "All organisations": the value of the organisation chosen in the user menu when
 * none is.
 *
 * This is a PRESENTATION value only — it is not itself a scope. `useListOrgScope` turns it into one,
 * and does so per role: '' becomes `allOrganisations` for a GlobalAdmin but `ownOrganisation` for
 * everyone else, because they cannot choose and '' is all they ever have.
 */
export const ALL_ORGANISATIONS = '';
